"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRxRohr = exports.rxRohrUseableDef = void 0;
const KetteSerieType_1 = require("./KetteSerieType");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.rxRohrUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.rxRohr,
    },
};
exports.isRxRohr = echain_shared_modelling_1.UseableUtil.createGuard(exports.rxRohrUseableDef);
//# sourceMappingURL=RxRohr.js.map